import { arc } from 'd3'

import { degreesToRadians } from '../../guided-toolbox/utils/utils'

// Extend the semicircle by 6° on each side to make the gauge look fuller.
// d3 angles start at the top and increase clockwise.
const SEMICIRCLE_DEGREES = 180
const OVERSHOOT_DEGREES = 6
export const END_ANGLE = degreesToRadians(SEMICIRCLE_DEGREES / 2 + OVERSHOOT_DEGREES)
export const START_ANGLE = -END_ANGLE
const SWEEP = END_ANGLE - START_ANGLE

export const clampPercent = value => {
  const number = Number(value)
  if (Number.isNaN(number)) return 0
  return Math.min(Math.max(number, 0), 100)
}

// Maps 0–100% from the lower-left, through the top, to the lower-right.
export const percentToAngle = percent => START_ANGLE + (clampPercent(percent) / 100) * SWEEP

// Point along the gauge at the given distance from center; y is negated
// because SVG's y-axis points down.
export const pointOnGauge = (percent, radius) => {
  const angle = percentToAngle(percent)
  return { x: Math.sin(angle) * radius, y: -Math.cos(angle) * radius }
}

// Set cornerRadius on the generator; d3.arc ignores it on the datum.
export const buildArcPath = ({
  innerRadius,
  outerRadius,
  fromPercent = 0,
  toPercent = 100,
  cornerRadius = 0,
}) =>
  arc()
    .innerRadius(innerRadius)
    .outerRadius(outerRadius)
    .cornerRadius(cornerRadius)
    .startAngle(percentToAngle(fromPercent))
    .endAngle(percentToAngle(toPercent))()

// Returns the SVG line endpoints for a radial tick at the given percentage.
export const tickMarkPoints = ({ percent, fromRadius, toRadius }) => {
  const inner = pointOnGauge(percent, fromRadius)
  const outer = pointOnGauge(percent, toRadius)
  return { x1: inner.x, y1: inner.y, x2: outer.x, y2: outer.y }
}
